import React from 'react';
import Chart from './Chart';

const DoughnutChart = (props) => <Chart type="doughnut" {...props} />;

export default DoughnutChart;
